import { Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import PrivacyPolicy from 'src/components/general/PrivacyPolicy';
import TextPageWrapper from '..';
export default function TermsOfServicePage() {
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(TextPageWrapper, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h2"
  }, t('general.terms_and_conditions')), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(PrivacyPolicy, null));
}